import queryString from "query-string";
import { getService, postService, putService } from "../../../commonServices";
import { appBaseUrl } from "utils/config";

export class EmailDeliveryService {
  GetDetails(id) {
    let url = `${appBaseUrl}/mailMessageCenter/emailLogsDetails/${id}`;
    let data = getService(url);
    return data;
  }
}
